/**
 *  _ __  _____      _______      __   ___ ___  _ __ ___
 * | '_ \/ __\ \ /\ / / _ \ \ /\ / /  / __/ _ \| '__/ _ \
 * | | | \__ \\ V  V / (_) \ V  V /  | (_| (_) | | |  __/
 * |_| |_|___(_)_/\_/ \___/ \_/\_/    \___\___/|_|  \___|
 *
 * ns.wow WordPress components
 * by Neidhart + Schön Group
 */

// Bundle core dependencies

import _ from 'expose-loader?exposes=_!lodash';

// Bundle polyfills for ns.wow plugins and theme

import "core-js";
import "custom-event-polyfill";
import "object-fit-polyfill";
import "promise-polyfill";
import "smoothscroll-polyfill";
import "url-search-params-polyfill";
import "whatwg-fetch";

// Bundle plugin module (NSCore)

import { createHooks } from '@wordpress/hooks';
import Platform from './Platform.js';

const Hooks = createHooks();

export default {

  version: () => {
    return NSContext.plugins.core.version;
  },

  getSiteUrl: () => {
    return Platform.getSiteUrl();
  },

  getAjaxUrl: () => {
    return Platform.getAjaxUrl();
  },

  getRestUrl: () => {
    return Platform.getRestUrl();
  },

  getPluginUrl: () => {
    return Platform.getPluginUrl();
  },

  getThemeUrl: () => {
    return Platform.getThemeUrl();
  },

  // Façade for @wordpress/hooks

  addAction: (hookName, namespace, callback, priority = 10) => {
    return Hooks.addAction(hookName, namespace, callback, priority);
  },

  addFilter: (hookName, namespace, callback, priority = 10) => {
    return Hooks.addFilter(hookName, namespace, callback, priority);
  },

  removeAction: (hookName, namespace) => {
    return Hooks.removeAction(hookName, namespace);
  },

  removeFilter: (hookName, namespace) => {
    return Hooks.removeFilter(hookName, namespace);
  },

  hasAction: (hookName, namespace) => {
    return Hooks.hasAction(hookName, namespace);
  },

  hasFilter: (hookName, namespace) => {
    return Hooks.hasFilter(hookName, namespace);
  },

  removeAllActions: (hookName) => {
    return Hooks.removeAllActions(hookName);
  },

  removeAllFilters: (hookName) => {
    return Hooks.removeAllFilters(hookName);
  },

  doAction: (hookName, ...args) => {
    return Hooks.doAction(hookName, ...args);
  },

  applyFilters: (hookName, ...args) => {
    return Hooks.applyFilters(hookName, ...args);
  },

  doingAction: (hookName) => {
    return Hooks.doingAction(hookName);
  },

  doingFilter: (hookName) => {
    return Hooks.doingFilter(hookName);
  },

  didAction: (hookName) => {
    return Hooks.didAction(hookName);
  },

  didFilter: (hookName) => {
    return Hooks.didFilter(hookName);
  },

  actions: Hooks.actions,

  filters: Hooks.filters

};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  // Customize hack for WP backend styles

  if (document.body.classList.contains('wp-admin')) {
    const excludedPages = ['acf-admin-page'];
    Platform.hideContent();
    if (!excludedPages.some(className => document.body.classList.contains(className))) {
      Platform.patchAdminPageHeader();
      Platform.patchAdminSubHeader();
      Platform.patchAdminNotices();
    }
    Platform.showContent();
  }

});
